import { Box, styled } from '@mui/material';

export const StyledAccountSection = styled(Box)(({ theme }) => ({
	padding: theme.spacing(2),
	height: '100%',
	[theme.breakpoints.down('sm')]: {
		borderBottom: `1px solid ${theme.palette.divider}`,
	},
}));
